import { ThemeEvents } from '@theme/events';

/**
 * Stock line under the product price (blocks/stock-status.liquid). Switches between
 * "In stock" and "Sold out" whenever the variant picker selects a different variant.
 */
class StockStatus extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // A null resource means the chosen option combination doesn't exist as a variant.
    const available = Boolean(event.detail.resource?.available);
    this.dataset.available = String(available);
    const text = this.querySelector('.stock-status__text');
    if (text) text.textContent = (available ? this.dataset.labelInStock : this.dataset.labelSoldOut) ?? '';
  };
}

if (!customElements.get('stock-status')) {
  customElements.define('stock-status', StockStatus);
}
